

import { useState,useEffect } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

import { useNavigate, useParams } from "react-router-dom";
import { loginSuccessSensor } from "../redux/slices/singleSensorSlice";
import { loginSuccessAllSens } from "../redux/slices/allSensorSlice";

import apiService from "../api/ApiService";
import { loginSuccessC } from "../redux/slices/singleCattleSlice";
import { useForm } from "react-hook-form";
import { isEqual } from "./EditModalDam";
import { Close, Cyclone } from "@mui/icons-material";


const ChangeStatusCycle=({tit,idd})=>{
    const mainProp={cattleLifeCycleId:idd}
    const [valid,setValid]=useState(false)
    const [AllStatus,setAllStatus]=useState([])
    const {closeWarn,isModalWarnOPen,openWarn}=useGlobalContext();
    const {id}=useParams()
    const dispatch=useDispatch();
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});
    const getStatus=async()=>{
                const res=await apiService.getCattleCycleStatusList()
                const res2=await apiService.getOrderCycle()
                const filtered=res.data.filter(item=>{
                    return item?.id!=idd
                })
                const filterOrders=res2.data.data.filter(item=>{
                    return item.fromCattleLifeCycle.id===idd
                      
                }).map(item=>{
                    return item?.toCattleLifeCycle

                })
                setAllStatus(filterOrders)
        }
useEffect(()=>{
    getStatus()
},[])
   
const allData=watch()
useEffect(()=>{setValid(isEqual(mainProp,allData))},[allData])
    const updateStatus=async(data)=>{    
                        
                        const res=await apiService.changeCattleLifeCycle(id,data)
                        dispatch(loginSuccessC(res.data))
                        openWarn()
    }
    

    return <div onClick={closeWarn} className={`modal-overlay ${isModalWarnOPen&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updateStatus)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>
            <h4 > تغییر چرخه دام</h4>
            </div>
       
            <div className="SelConn">
        <label for='sele' ><Cyclone fontSize="small"/> چرخه:</label>
        <select  id='sele'  name='sele' className="selectInp" {...register("cattleLifeCycleId",{required:'این مقدار ضروری است'})} >
        <option value={idd}>{tit}</option>

            {AllStatus?.map((item,index)=>{
                return <option key={index} value={item.id}>{item.title}</option>
            })}
        </select>
        </div>
        
        <button className="EditMOdalBtnForm" disabled={valid}>
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'220px'}}> 
        
        </div>
        
    </div>
}
export default ChangeStatusCycle